import { Component, Input } from '@angular/core';

import { RouterModule } from '@angular/router';
import { Section } from '../../../dto/response/template.config';

@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss',
})
export class TopBarComponent {
  @Input() section: Section | undefined;
}
